import { clamp } from "apparatus/library/common";
import { commandProcessor } from "command/command";
import * as React from "react";
import store from "store/store";
import { ZoomCommand } from "view/zoom";
/**
 * Component to display the zoom slider.
 */
export class ZoomSlider extends React.Component {
    constructor() {
        super(...arguments);
        /** Ref to the DOM element. */
        this.elementRef = React.createRef();
    }
    executeZoomCommand(zoom) {
        if (store.zoom() != zoom) {
            // Don't set zero zoom.
            zoom = Math.max(0.01, zoom);
            // BUG: updating the zoom externally causes slidechange to trigger which may trigger another
            // zoom command, so we have to make sure to merge with previous command.
            // Unfortunately solving this by guarding against miniscule differences between store.zoom()
            // and zoom don't work.
            commandProcessor.executeReplacingLastCommand((lastCommand) => {
                if (!(lastCommand instanceof ZoomCommand))
                    return false;
                return new ZoomCommand(lastCommand.from, zoom);
            }, new ZoomCommand(this.props.zoom, zoom));
        }
    }
    componentDidMount() {
        let slider = $(this.elementRef.current);
        let self = this;
        slider.slider({
            value: getSliderValueFromZoom(this.props.zoom),
            min: -2,
            max: 2,
            step: 0.01,
            animate: "fast",
            // orientation: "vertical"
        }).slider("pips", {
            rest: "label",
            step: 100,
            labels: ["25%", "50%", "100%", "200%", "300%"]
        }).slider("float", {
            formatLabel: function (value) {
                return Math.floor(getZoomFromSliderValue(value) * 100) + "%";
            }
        }).on("slidestart", function (e, ui) {
            self.props.onStartZoom();
        }).on("slide", function (e, ui) {
            // Convert to zoom level.
            let zoomLevel = getZoomFromSliderValue(ui.value);
            self.props.onUpdateZoom(zoomLevel);
        }).on("slidestop", function (e, ui) {
            let newZoom = getZoomFromSliderValue(ui.value);
            self.executeZoomCommand(newZoom);
            self.props.onEndZoom();
        }).on("slidechange", function (e, ui) {
            let newZoom = getZoomFromSliderValue(ui.value);
            self.executeZoomCommand(newZoom);
            self.props.onEndZoom();
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.zoom != this.props.zoom) {
            let currentSliderValue = $(this.elementRef.current).slider("value");
            let currentZoom = getZoomFromSliderValue(currentSliderValue);
            if (currentZoom != this.props.zoom) {
                let newZoomSlider = getSliderValueFromZoom(this.props.zoom);
                $(this.elementRef.current).slider("value", newZoomSlider);
            }
        }
    }
    render() {
        return React.createElement("div", { id: "zoom-slider", key: "zoomSlider", ref: this.elementRef });
    }
}
/** Converts a slider value to Zoom value.  */
function getZoomFromSliderValue(value) {
    return (value < 0 ? Math.pow(2, value) : 1 + value);
}
/** Converts zoom value to slider value. */
function getSliderValueFromZoom(zoom) {
    return zoom <= 1 ? Math.log(zoom) / Math.log(2) : zoom - 1;
}
export function clampZoomValue(zoom) {
    return clamp(zoom, 0.25, 3);
}
